import { createKsStore, type KsStoreHook } from '@siclop/kstone-vue'
import { ServiceType } from '../models/ServiceType'
import { ServiceTypeForm } from '../forms/ServiceTypeForm'
import { ServiceTypeFilter } from '../filters/ServiceTypeFilter'
import { ServiceTypeService } from '../services/ServiceTypeService'

export const useServiceTypeStore: KsStoreHook<ServiceType, ServiceTypeForm, ServiceTypeFilter> = createKsStore({
  id: 'serviceTypes',
  modelClass: ServiceType,
  formClass: ServiceTypeForm,
  filterClass: ServiceTypeFilter,
  service: ServiceTypeService,
  uniqueField: 'code',
  labelField: (item) => item.label || item.code || `Type de service #${item.id}`,
  signalREventName: 'ServiceTypeModel',
  isReferential: true
})
